<template>
    <ion-page>
        <ion-header :translucent="true">
            <ion-toolbar>
                <ion-buttons slot="start">
                    <!-- <ion-menu-button color="primary"></ion-menu-button> -->
                    <router-link :to="this.$router.options.history.state.back ? this.$router.options.history.state.back : '/my-ship-pricing-log'" class="ion-padding">
                        <ion-icon :ios="chevronBackOutline" :md="chevronBack"></ion-icon>
                    </router-link>
                </ion-buttons>
                <ion-title>Update Ship Price</ion-title>
            </ion-toolbar>
        </ion-header>

        <ion-content :fullscreen="true">
            <div id="container">
                <ion-grid class="ion-text-left">
                    <ion-row>
                        <ion-col size="5"><b>Company Name:</b></ion-col>
                        <ion-col size="7">{{companyName}}</ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col size="5"><b>Client Name:</b></ion-col>
                        <ion-col size="7">{{clientName}}</ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col size="5"><b>Ship Name:</b></ion-col>
                        <ion-col size="7">{{shipName}}</ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col size="5"><b>Device Price:</b></ion-col>
                        <ion-col size="7">{{currentPrice['device_price']}}</ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col size="5"><b>Solar Panel Price:</b></ion-col>
                        <ion-col size="7">{{currentPrice['solar_panel_price']}}</ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col size="5"><b>Installation Charge:</b></ion-col>
                        <ion-col size="7">{{currentPrice['installation_charge']}}</ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col size="5"><b>Subscription Fee:</b></ion-col>
                        <ion-col size="7">{{currentPrice['monthly_subscription_fee']}}</ion-col>
                    </ion-row>
                </ion-grid>
                <hr style="border-bottom: 1px solid #afafaf ;" />
                <ion-item>
                    <ion-label position="floating">Device Price <span class="required">*</span></ion-label>
                    <ion-input mode="ios" type="tel" :value="postData['device_price']" v-model="postData['device_price']"></ion-input>
                </ion-item>
                <ion-item>
                    <ion-label position="floating">Solar Panel Price <span class="required">*</span></ion-label>
                    <ion-input mode="ios" type="tel" :value="postData['solar_panel_price']" v-model="postData['solar_panel_price']"></ion-input>
                </ion-item>
                <ion-item>
                    <ion-label position="floating">Installation Charge <span class="required">*</span></ion-label>
                    <ion-input mode="ios" type="tel" :value="postData['installation_charge']" v-model="postData['installation_charge']"></ion-input>
                </ion-item>
                <ion-item>
                    <ion-label position="floating">Monthly Subscription Fee <span class="required">*</span></ion-label>
                    <ion-input mode="ios" type="tel" :value="postData['monthly_subscription_fee']" v-model="postData['monthly_subscription_fee']"></ion-input>
                </ion-item>
                <ion-button expand="block" @click="save()" color="primary">Save</ion-button>
            </div>
        </ion-content>
    </ion-page>
</template>

<script>
    import {
        IonButtons,
        IonButton,
        IonContent,
        IonHeader,
        IonMenuButton,
        IonPage,
        IonTitle,
        IonToolbar,
        IonItem,
        IonLabel,
        IonInput,
        IonGrid,
        IonRow,
        IonCol,
        IonIcon,
        IonSelect,
        IonSelectOption,
        alertController
    } from '@ionic/vue';
    import {
        chevronBack,
        chevronBackOutline,
    } from "ionicons/icons";
    import Loading from '../../Loading';
    import Dropdown from '../modules/Dropdown.vue';
    export default {
        name: 'MyShipPriceUpdate',
        components: {
            IonButtons,
            IonButton,
            IonContent,
            IonHeader,
            // IonMenuButton,
            IonIcon,
            IonPage,
            IonTitle,
            IonToolbar,
            IonItem,
            IonLabel,
            IonInput,
            IonGrid,
            IonRow,
            IonCol,
            // Dropdown
        },
        data() {
            return {
                companyName:null,
                clientName:null,
                shipName:null,
                currentPrice: {
                    'device_price': null,
                    'solar_panel_price': null,
                    'installation_charge': null,
                    'monthly_subscription_fee': null,
                },
                postData: {
                    'ship_id': this.$route.params.shipId,
                    'device_price': null,
                    'solar_panel_price': null,
                    'installation_charge': null,
                    'monthly_subscription_fee': null,
                },
                chevronBackOutline,
                chevronBack,
            }
        },
        created() {
            const data = {
                'username': window.localStorage.username,
                'password': window.localStorage.password,
                'ship_id': this.$route.params.shipId,
            };
            this.$http.post('MyShipPricingLog/MySingleShip',data).then(response => {
                const ship= response.data.shipData;
                this.companyName = ship.client.company.company_name;
                this.clientName = ship.client.client_name;
                this.shipName = ship.ship_name;
                this.postData['ship_id'] = ship.id;
                this.postData['device_price'] = ship.device_price ? parseInt(ship.device_price) : 0;
                this.postData['solar_panel_price'] = ship.solar_panel_price ? parseInt(ship.solar_panel_price) : 0;
                this.postData['installation_charge'] = ship.installation_charge ? parseInt(ship.installation_charge) : 0;
                this.postData['monthly_subscription_fee'] = ship.monthly_subscription_fee ? parseInt(ship.monthly_subscription_fee) : 0;

                this.currentPrice['device_price'] = ship.device_price ? parseInt(ship.device_price) : 0;
                this.currentPrice['solar_panel_price'] = ship.solar_panel_price ? parseInt(ship.solar_panel_price) : 0;
                this.currentPrice['installation_charge'] = ship.installation_charge ? parseInt(ship.installation_charge) : 0;
                this.currentPrice['monthly_subscription_fee'] = ship.monthly_subscription_fee ? parseInt(ship.monthly_subscription_fee) : 0;
            });
        },
        methods: {
            async save(){
                if(confirm('Are you sure to update the price?')){
                    const data = {
                        'username': window.localStorage.username,
                        'password': window.localStorage.password,
                        'ship_id': this.postData['ship_id'],
                        'device_price': this.postData['device_price'],
                        'solar_panel_price': this.postData['solar_panel_price'],
                        'installation_charge': this.postData['installation_charge'],
                        'monthly_subscription_fee': this.postData['monthly_subscription_fee'],
                    };
                    this.$http.post('MyShipPricingLog/MySingleShip/update', data).then(response => {
                        const ship = response.data.ship;
                        if(response.data.status){
                            this.postData['ship_id'] = ship.id;
                            this.postData['device_price'] = parseInt(ship.device_price);
                            this.postData['solar_panel_price'] = parseInt(ship.solar_panel_price);
                            this.postData['installation_charge'] = parseInt(ship.installation_charge);
                            this.postData['monthly_subscription_fee'] = parseInt(ship.monthly_subscription_fee);

                            this.currentPrice['device_price'] = parseInt(ship.device_price);
                            this.currentPrice['solar_panel_price'] = parseInt(ship.solar_panel_price);
                            this.currentPrice['installation_charge'] = parseInt(ship.installation_charge);
                            this.currentPrice['monthly_subscription_fee'] = parseInt(ship.monthly_subscription_fee);
                            this.presentResponseAlert('success',response.data.message);
                            console.log(this.$router);
                            this.$router.push(this.$router.options.history.state.back);
                        }
                    });
                }
                
            },
            async presentResponseAlert(type, message) {
                const alert = await alertController
                    .create({
                        header: type + '!',
                        // subHeader: 'Subtitle',
                        message: message,
                        buttons: ['OK'],
                    });
                await alert.present();
            },
            async presentAlert(message) {
                const alert = await alertController
                    .create({
                        header: 'Alert!',
                        // subHeader: 'Subtitle',
                        message: message + " is required",
                        buttons: ['OK'],
                    });
                await alert.present();
            },
            async confirmationAlert(message) {
                const alert = await alertController.create({
                header: message,
                buttons: [
                    {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        this.handlerMessage = false;
                    },
                    },
                    {
                    text: 'OK',
                    role: 'confirm',
                    handler: () => {
                        this.handlerMessage = true;
                    },
                    },
                ],
                });

                const val = await alert.present();

                const { role } = await alert.onDidDismiss();
                return val;
            },
        },
    }
</script>

<style scoped>
    #container {
        text-align: center;
        position: absolute;
        left: 0;
        right: 0;
        /* top: 50%; */
        /* transform: translateY(-50%); */
    }

    #container strong {
        font-size: 20px;
        line-height: 26px;
    }

    #container p {
        font-size: 16px;
        line-height: 22px;
        color: #8c8c8c;
        margin: 0;
    }

    #container a {
        text-decoration: none;
    }

    .p-dropdown {
        width: 100%;
        color: #000;
    }

    .required {
        color: rgb(233, 0, 0)
    }
</style>